import { render, staticRenderFns } from "./DeleteCompanyButton.vue?vue&type=template&id=5eed55e3"
import script from "./DeleteCompanyButton.vue?vue&type=script&lang=js"
export * from "./DeleteCompanyButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports